export default {
    findMenus: { method: 'get', url: 'menus?with=children' },
    store: { method: 'post', url: 'menus' },
    update: { method: 'put', url: 'menus/{id}' },
    destroy: { method: 'delete', url: 'menus/{id}'}
}